import styled from "styled-components";
import bg1 from "./assets/Graphics/bg1.png";

export const Container = styled.div`
  /* max-width: 900px; */
  /* position: relative; */
  margin: 2em clamp(0.1em, 8vw, 300px);

  @media (max-width: 576px) {
    margin: 0 0.8em;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f5ef;
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  max-width: 900px;
  margin: 2em auto;
  position: relative;
  overflow: visible;

  @media (max-width: 576px) {
    padding: 1rem;
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  color: #344b45;
  text-align: center;
  margin-bottom: 1rem;
  padding-top: 2em;
  span {
    display: block;
    font-size: 16px;
    padding: 1em;
  }
`;

export const H3 = styled.h3`
  /* color: #273743; */

  text-align: center;
  font-family: ${(props) => props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};

  font-size: clamp(20px, 2.2vw, 5em);
  padding: 0.7em 0;
  /* text-transform: uppercase; */
  letter-spacing: -1px;

  background-image: url(${bg1});
  line-height: 1.3em;
  background-size: contain;
  /* background-size: auto; */
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  /* background-color: red; */
  text-align: center;
  margin: 1em auto;
  max-width: 14em;
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #4a5d58;
  text-align: center;
  line-height: 1.5;
  padding-bottom: 1em;
`;

export const ShapeTopLeft = styled.div`
  position: absolute;
  /* background-color: #c39442; */
  border-radius: 8px;
  top: -3em;
  left: ${(props) => props.lang === "en" ? "0" : "70px"};
  right: ${(props) => props.lang === "en" ? "0" : "70px"};
  object-fit: contain;

  img {
    width: 150px;
    height: 150px;
  }
  @media (max-width: 768px) {
    left: auto;
  }
`;

export const ShapeBottomRight = styled.div`
  position: absolute;
  img {
    width: 170px;
    height: 170px;
  }
  /* background-color: #c39442; */
  /* border: 0.1px solid black; */
  border-radius: 8px;
  bottom: -4em;
  right: 70px;
  object-fit: contain;
  @media (max-width: 768px) {
    right: auto;
  }
`;
